module.exports = __webpack_public_path__ + "img/30.370ebf38.jpg";